/* eslint-disable react/jsx-props-no-spreading */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { sanitizeRichText } from '@utils/sanitizeHtml';
import './FeedbackImage.scss';
import AppPageContentWrapper from '@part/AppPageContentWrapper';
import { ButtonPrimary } from '@core/ButtonPrimary';
import { Link } from '@core/Link';
import Ta11yImage from '@core/Ta11yImage';
import Icons from '@core/Utils/Icons/Icons';
import { getKeyByValue, appIconsPath } from '@utils/globalConstant';


export function FeedbackImage({
  children = null,
  image = '',
  imageName = '',
  icon = '',
  iconName = '',
  headingContent = {},
  copyTextContent = {},
  copyText2Content = {},
  teaserCard = null,
  buttonContent,
  contentImage = '',
  contentImages = [],
  contentImageName = '',
  buttonType = '',
  buttonIcon = '',
  buttonClick,
  linkText = '',
  linkIcon = '',
  linkStyle = '',
  linkRef = '#',
  replaceTitle,
  replaceTitleBy,
}) {
  // State & Refs

  // Functions
  const feedbackIcon = getKeyByValue(appIconsPath,icon);

  // hooks

  return (
    <div className='feedback-image min-dvh-100 w-100 bg-ek-lightblue'>
      <div className="feedback-img-container">
        {typeof(image) !== 'string' ? <Ta11yImage
          imageContent={image} className="feedback-img-container"
        /> : <img src={image} alt={imageName} className='' />}
      </div>
      <div className="feedback-details-container w-100 position-relative bg-ek-lightblue d-flex justify-content-center">
        <div className="bubble-container bg-ek-lightblue position-absolute rounded-circle">
          {icon ? <Icons name={feedbackIcon} alt={iconName} colorType='dark' /> : ''}
        </div>
        <AppPageContentWrapper>
          <div className="content-main-container w-100 h-100 d-flex align-items-center flex-column ">
            {headingContent.content !== '' &&
              headingContent.content !== undefined &&
              (headingContent.isHtml ? (
                <div className="title-container text-center">
                  <h1
                    className="ek-h1 text-primary m-0"
                    dangerouslySetInnerHTML={{ __html: sanitizeRichText(headingContent.content.replace(replaceTitle, replaceTitleBy)) }}
                  />
                </div>
              ) : (
                <div className="title-container text-center">
                  <h1 className="ek-h1 text-primary m-0">{headingContent.content.replace(replaceTitle, replaceTitleBy)}</h1>
                </div>
              ))}

            {copyTextContent.content !== '' &&
              copyTextContent.content !== undefined &&
              (copyTextContent.isHtml ? (
                <div className="sub-title-container text-center">
                  <p
                    className="ek-copy-16-regular text-primary pt-24"
                    dangerouslySetInnerHTML={{ __html: sanitizeRichText(copyTextContent?.content) }}
                  />
                </div>
              ) : (
                <div className="sub-title-container text-center">
                  <p className="ek-copy-16-regular text-primary pt-24">
                    {copyTextContent?.content}
                  </p>
                </div>
              ))}
            {copyText2Content.content !== '' &&
              copyText2Content.content !== undefined &&
              (copyText2Content.isHtml ? (
                <div className="sub-title-container text-center">
                  <p
                    className="ek-copy-16-regular text-primary pt-24"
                    dangerouslySetInnerHTML={{ __html: sanitizeRichText(copyText2Content?.content) }}
                  />
                </div>
              ) : (
                <div className="sub-title-container text-center">
                  <p className="ek-copy-16-regular text-primary pt-24">
                    {copyText2Content?.content}
                  </p>
                </div>
              ))}

            {contentImage ? <div className="content-image-container text-center w-100">
              {typeof(contentImage) !== 'string' ? <Ta11yImage
                imageContent={contentImage} className="pt-24"
              /> : <img src={contentImage} alt={contentImageName} className='pt-24' />}
            </div> : ""}

            {contentImages.length > 0 && 
              <div className="col-12 col-sm px-md-0 mt-24 flex-grow-1 d-flex justify-content-center align-items-center">
                { contentImages.map((contentImage, index) => (
                  <div className="footer-images pe-12">
                    {contentImage ? <Ta11yImage
                      imageContent={contentImage}
                      className='footer-image footer-image--first'
                    /> : ''}
                  </div>
                ))
                }
              </div>
            }

            {teaserCard && (
              <div className="mt-40 w-100">
                {teaserCard}
              </div>
            )}

            {buttonContent && (
              <>
                <div className="space-40" />
                <ButtonPrimary
                  iconRight={buttonIcon}
                  buttonType={buttonType}
                  buttonContent={buttonContent}
                  onClick={() => buttonClick()}
                />
              </>
            )}
            {linkText && linkRef ? (
              <>
                <div className="space-24" />
                <Link
                  label={linkText}
                  iconRight={linkIcon}
                  linkStyle={linkStyle}
                  // linkSize={linkSize}
                  linkRef={linkRef}
                />
                <div className="space-24" />
              </>
            ) : (
              ''
            )}
          </div>
        </AppPageContentWrapper>
      </div>
    </div>
  );
}

FeedbackImage.propTypes = {
  children: PropTypes.node,
  image: PropTypes.any,
  imageName: PropTypes.string,
  icon: PropTypes.string,
  iconName: PropTypes.string,
  title: PropTypes.string,
  subText: PropTypes.string,
  teaserCard: PropTypes.node,
  contentImage: PropTypes.any,
  contentImageName: PropTypes.string,
  buttonType: PropTypes.string,
  buttonIcon: PropTypes.string,
  linkText: PropTypes.string,
  linkIcon: PropTypes.string,
  linkStyle: PropTypes.string,
  linkRef: PropTypes.string,
};

export default FeedbackImage;
